import React from 'react';
import {
  useReactTable,
  createColumnHelper,
  getCoreRowModel,
} from '@tanstack/react-table';

import { formatNumberToInternational } from "../../../../utils/utils";


const App = (props) => {
  
  const { columnsData, tableData, tableName, onActionClick
   } = props;

  const columnHelper = createColumnHelper();
  const boldColumns = new Set(["SUB-TOTAL 1", "SUB-TOTAL 2", "SALDO TOTAL 1", "TOTAL SAIDAS", "SUB-TOTAL", "SALDO TOTAL", "TOTAL DAS ENTRADAS (1 + 2)", "SALDO APURANDO"]);


  const columns = [
    columnHelper.accessor('descricao', {
      header: tableName,
      cell: info => (
        <div style={{ textAlign: boldColumns.has(info.getValue()) ? 'right' : 'left', width: boldColumns.has(info.getValue()) ? '' : '400px' }}>
          {info.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor('jpy', {
      header: 'YJP',
      cell: info => (
        <div style={{ textAlign: 'right', width: '120px' }}>
          {info.getValue() ? formatNumberToInternational(info.getValue()) : ''}
        </div>
      ),
    }),
    columnHelper.accessor('usd', {
      header: 'USD',
      cell: info => (
        <div style={{ textAlign: 'right', width: '120px' }}>
          {info.getValue() ? formatNumberToInternational(info.getValue()) : ''}
        </div>
      ),
    }),
    columnHelper.accessor('eur', {
      header: 'EUR',
      cell: info => (
        <div style={{ textAlign: 'right', width: '120px' }}>
          {info.getValue() ? formatNumberToInternational(info.getValue()) : ''}
        </div>
      ),
    }),
  ];
  

  const table = useReactTable({
    data : tableData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <table
        border="1"
        style={{
          borderCollapse: 'collapse',
          width: '100%',
          border: '1px solid black', // Outer black border
        }}
      >
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, index) => (
                <th
                  key={header.id}
                  colSpan={header.colSpan}
                  style={{
                    padding: '4px',
                    textAlign: 'center',
                    fontSize: '14px',
                    backgroundColor: '#f0f0f0',
                    borderBottom: '1px solid #000', // Bottom border between header and body
                    borderRight: index < headerGroup.headers.length - 1 ? '1px solid #000' : '', // Vertical separator between columns
                  }}
                >
                  {header.isPlaceholder ? null : header.column.columnDef.header}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map(row => {
            const description = row.getVisibleCells()[0]?.getContext()?.getValue?.();
            const isBold = boldColumns.has(description);
            return <tr
                key={row.id}
                style={{
                  fontWeight: isBold ? 'bold' : 'normal', // Apply bold style conditionally
                  backgroundColor: isBold ? '#f0f0f0' : '',
                }}>
              {row.getVisibleCells().map((cell, index) => (
                <td
                  key={cell.id}
                  style={{
                    padding: '4px',
                    fontSize: '12px',
                    textAlign: 'center',
                    borderBottom: '1px solid #000', // Line between rows
                    borderRight: index < row.getVisibleCells().length - 1 ? '1px solid #000' : '', // Vertical separator between columns
                  }}
                >
                  {cell.column.columnDef.cell?.(cell.getContext())}
                </td>
              ))}
            </tr>
          })}
        </tbody>
      </table>
    </div>
  );
};

export default App;
